import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Batch, BatchOrder, BatchOrdersRepositoryService, ListComponent, eBatchType } from 'reg-hub-common';
import { BatchErrorsPopupComponent } from '../batch-errors-popup/batch-errors-popup.component';

@Component({
    selector: 'app-batch-orders-list',
    templateUrl: './batch-orders-list.component.html',
    styleUrl: './batch-orders-list.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BatchOrdersListComponent extends ListComponent<BatchOrder> implements OnInit {
  @Input() batch!: Batch;

  displayedColumns: string[] = [
    'referenceNumber',
    'isStaged',
    'isProcessed',
    'isSubmitted',
    'orderTypeID',
    'orderStatusTypeID',
    'requestErrors',
    'requestWarnings',
    'view',
  ];

  vinSightBatchType = eBatchType.vinSight;

  constructor(
    repo: BatchOrdersRepositoryService,
    private router: Router,
    private dialog: MatDialog) {
    super(repo);
  }

  ngOnInit(): void {

  }

  protected hasWarnings(batchOrder: BatchOrder) {
    return ((batchOrder.validationWarnings?.length ?? 0) > 0);
  }

  protected viewValidationWarnings(batchOrder: BatchOrder) {
    this.dialog.open(BatchErrorsPopupComponent, {
      data: batchOrder.validationWarnings ?? batchOrder.requestWarnings,
      minWidth: '800px'
    })
  }

  protected hasErrors(batchOrder: BatchOrder) {
    return ((batchOrder.validationErrors?.length ?? 0) > 0 || batchOrder.requestErrors);
  }

  protected viewErrors(batchOrder: BatchOrder) {
    var error = ((batchOrder.validationErrors?.length ?? 0) > 0) ? batchOrder.validationErrors : batchOrder.requestErrors;
    this.dialog.open(BatchErrorsPopupComponent, {
      data: error,
      minWidth: '800px'
    })
  }

  protected viewVinSights(batchOrder: BatchOrder, newTab: boolean) {
    const queryParams = { serialNumber: batchOrder.requestJson };

    if (newTab) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(
          ['vinsights'],
          { queryParams }
        )
      );

      window.open(url, '_blank');
    } else {
      this.router.navigate(
        ['vinsights'],
        { queryParams }
      );
    }
  }

  protected viewOrder(batchOrder: BatchOrder, newTab: boolean) {
    if (newTab) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['orders', batchOrder.orderID!])
      );

      window.open(url, '_blank');
    }
    else {
      this.router.navigate(['orders', batchOrder.orderID!])
    }
  }

  protected shouldShowVinSightViewButtons(batchOrder: BatchOrder) {
    return this.batch.batchTypeID == eBatchType.vinSight && batchOrder.isCompleted
  }
}
